import React from "react";
import { Tooltip } from "@mui/material";

import { SenderType } from "./GroupMessageSearchInput";
import { SendersCounter, SendersListWrapper } from "../GroupHeader.style";

interface SendersViewProps {
  senders: SenderType[];
}

const SendersList = ({ senders = [] }: SendersViewProps): React.JSX.Element => {
  if (senders.length === 0) return <></>;

  const tooltipContent = senders.map(s => s.name).join(", ");

  return (
    <SendersListWrapper>
      <Tooltip title={tooltipContent} arrow>
        <SendersCounter data-testid="SelectedCount">
          {senders.length}
        </SendersCounter>
      </Tooltip>
    </SendersListWrapper>
  );
};

export default SendersList;
